import { Modal } from '@st-operations/uikit/src/v2'
import React from 'react'

import UnifiedUserProfileWizardWelcome from './welcome'

import './styles.scss'

const UnifiedUserProfileModal = ({ isOpen, onClose, onCreate }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ padding: 0 }}
      classes={{
        content: 'unified-user-profile-wizard__modal-content',
        childWrapper: 'unified-user-profile-wizard__modal-child-wrapper',
        innerWrapper: 'unified-user-profile-wizard__modal-inner-wrapper',
        header: 'unified-user-profile-wizard__modal-header',
      }}
    >
      <UnifiedUserProfileWizardWelcome onCreate={onCreate} />
    </Modal>
  )
}

export default UnifiedUserProfileModal
